import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { api, apiErr } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) { setError(apiErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#06080c] text-white p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-sm rounded-2xl bg-[#0f131b] border border-white/10 p-8 shadow-2xl">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="h-10 w-10 text-[#38bdf8] mx-auto mb-3" />
            <h1 className="text-xl font-bold mb-2">Check your email</h1>
            <p className="text-white/60 text-sm mb-6">If an account exists for <b>{email}</b>, we've sent a link to reset your password. The link expires in 60 minutes.</p>
            <button onClick={() => navigate("/login")} className="w-full h-11 rounded-lg bg-[#38bdf8] text-[#06121b] font-semibold">Back to sign in</button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <button type="button" onClick={() => navigate("/login")} className="text-white/50 hover:text-white flex items-center gap-1.5 text-sm mb-4"><ArrowLeft className="h-4 w-4" /> Sign in</button>
            <h1 className="text-xl font-bold mb-1">Forgot your password?</h1>
            <p className="text-white/50 text-sm mb-5">Enter your email and we'll send you a reset link.</p>
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" autoFocus
              className="w-full h-11 rounded-lg bg-white/5 border border-white/10 px-3.5 text-sm outline-none focus:border-[#38bdf8]/60 mb-3" />
            {error && <div className="text-sm text-red-300 mb-3" data-testid="forgot-error">{error}</div>}
            <button data-testid="forgot-submit" disabled={busy || !email} className="w-full h-11 rounded-lg bg-[#38bdf8] text-[#06121b] font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
